import { render, staticRenderFns } from "./view-abnormal.vue?vue&type=template&id=3997ff2d"
import script from "./view-abnormal.vue?vue&type=script&lang=js"
export * from "./view-abnormal.vue?vue&type=script&lang=js"
import style0 from "./view-abnormal.vue?vue&type=style&index=0&id=3997ff2d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_ptp2uvm53q35aphlzqn6rhtzgm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports